import SearchApi from 'bundles/discussions/api/SearchApi';
import { FluxibleActions, loadingStates } from 'bundles/discussions/constants';

const receiveSearchResults = (
  actionContext: $TSFixMe,
  forumId: $TSFixMe,
  query: $TSFixMe,
  pageNum: $TSFixMe,
  response: $TSFixMe
) => {
  actionContext.dispatch(FluxibleActions.SEARCH_RESULTS_RECEIVED, {
    pageNum,
    forumId,
    query,
    naptimeResponse: response,
  });
};

const searchApiError = (actionContext: $TSFixMe, err: $TSFixMe) => {
  actionContext.dispatch(FluxibleActions.SEARCH_API_ERROR, { err });
};

export const search = function (
  actionContext: $TSFixMe,
  { query, filterQueryString, forumId, contextId, forumType, reset = false, pageNum = 1, includeDeleted }: $TSFixMe,
  done: $TSFixMe
) {
  actionContext.dispatch(FluxibleActions.UPDATE_LOADING_STATE, loadingStates.LOADING);

  if (reset) {
    actionContext.dispatch(FluxibleActions.CLEAR_DISCUSSIONS_SEARCH_STORE);
  }

  SearchApi.searchFor({
    query,
    filterQueryString,
    forumType,
    forumId,
    contextId,
    pageNum,
    includeDeleted,
  })
    .then((response) => receiveSearchResults(actionContext, forumId, query, pageNum, response))
    .fail((error) => searchApiError(actionContext, error))
    .done(() => done());
};

export const goToPage = function (
  actionContext: $TSFixMe,
  { query, filterQueryString, pageNum, forum, forumId, contextId, forumType, includeDeleted }: $TSFixMe,
  done: $TSFixMe
) {
  const store = actionContext.getStore('DiscussionsSearchStore');
  const res = store.searchResults({ forumId, pageNum });
  actionContext.dispatch(FluxibleActions.UPDATE_LOADING_STATE, loadingStates.LOADING);
  if (res.length === 0) {
    SearchApi.searchFor({
      query,
      filterQueryString,
      forumType,
      forumId,
      contextId,
      pageNum,
      includeDeleted,
    })
      .then((response) => {
        actionContext.dispatch(FluxibleActions.SEARCH_PAGE_CHANGE, {
          pageNum,
          filterQueryString,
          naptimeResponse: response,
          forumId,
          query,
        });
      })
      .fail((error) => searchApiError(actionContext, error))
      .done(() => done());
  } else {
    actionContext.dispatch(FluxibleActions.SEARCH_PAGE_CHANGE, {
      pageNum,
      filterQueryString,
      forumId,
      query,
    });
    done();
  }
};

export default { search, goToPage };
